import { useFormContext } from "react-hook-form";

import SearchIcon from "@/assets/icons/magnifying-glass.svg";
import { FILTER } from "@/constants";
import { Input } from "@components/Field";
import Adornment from "@components/Field/Adornment";
import { InputProps } from "@components/Field/Base/Input";

import styles from "./FreeText.module.css";

const FreeText = (props: Partial<InputProps>) => {
  const { register } = useFormContext();
  return (
    <div className={styles.root}>
      <Input
        block
        endAdornment={
          <Adornment position="end">
            <SearchIcon />
          </Adornment>
        }
        data-testid="filter-bar--freetext"
        type="search"
        autoComplete="off"
        autoCorrect="off"
        placeholder={L.MENTIONS_VIEW_TOOLBAR_FILTER_FREETEXT_PLACEHOLDER}
        {...props}
        {...register(FILTER.FREETEXT, {
          setValueAs: (value) => (value ? value : undefined),
        })}
      />
    </div>
  );
};

export default FreeText;
